import { render, staticRenderFns } from "./WeeklySendModal.vue?vue&type=template&id=df02d272&scoped=true"
import script from "./WeeklySendModal.vue?vue&type=script&lang=js"
export * from "./WeeklySendModal.vue?vue&type=script&lang=js"
import style0 from "./WeeklySendModal.vue?vue&type=style&index=0&id=df02d272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df02d272",
  null
  
)

export default component.exports